<template>
	<div class="popup">
		<div class="title row-center" style="justify-content: space-between">
			<div class="enum row-center" style="justify-content: space-between">
				<div :class="{active:isActive==0}" @click="isActive=0;isCheck=0">MPPT</div>
				<div :class="{active:isActive==1}" @click="isActive=1;isCheck=1">组串</div>
			</div>
			<div class="close" @click="$emit('checkClose',false)"></div>
		</div>

		<div class="tab" v-if="isActive==0&&isCheck==0">
			<div class="head row-center" style="justify-content: space-between">
				<div>名称</div>
				<div>电压（V）</div>
				<div>电流（A）</div>
			</div>
			<div class="rows">
				<el-scrollbar style="height:100%">
					<div class="row row-center" style="justify-content: space-between" v-for="item in realData" >
						<div>{{item.name}}</div>
						<div>{{mqttval(item.U)}}</div>
						<div>{{mqttval(item.I)}}</div>
					</div>
				</el-scrollbar>
			</div>
		</div>
		<div class="tab" v-else>
			<div class="head row-center" style="justify-content: space-between">
				<div style="width:50%">名称</div>
				<div style="width:50%">电流（A）</div>
			</div>

			<div class="rows">
				<el-scrollbar style="height:100%">
					<div v-if="StringData.length<=0" class="nodata"><img src="../../assets/img/not_found_data.png" alt=""></div>
					<div class="row row-center" style="justify-content: space-between" v-for="item in StringData" v-else>
						<div style="width:50%">{{item.name}}</div>
						<div style="width:50%">{{mqttval(item.I)}}</div>
					</div>
				</el-scrollbar>
			</div>
		</div>
	</div>
</template>

<script>
	import { floatFormat } from "../../util/MathUtil";
	export default {
		name: "Popup",
		props:{
			isCheck:Number,
			currentLoop:Object
		},
		data(){
			return {
				isActive:0,
				mppt:[200.1,300.8,190.9,206.4,268.4,199.9,300.4,269.5,200.1,300.8,190.9,206.4,268.4,199.9,300.4,269.5,206.4,268.4,199.9,300.4,269.5,200.1,300.8,],
				current:[23,21,98,25,45,68,155,156,220,77,66,35,98,25,45,68,155,156,220,77,66,23,56,98,25,45,68,155,156,220],
				strings:[101,166,145,189,231,169,123,172,166,145,189,231,169,123,172,166,145,189,231,169,123,172],
				strings2:[11,16,14,22,12,10,23,25,16,14,22,12,10,23,25,10,23,25,16,14,22,12,10,23,25]
			}
		},
		computed:{
			mqttval() {
				return this.getMqttVal(this.$store.getters.mqttVal);
			},
			//组串
			StringData(){
				if(this.currentLoop.subLoopUrl == "T1/1AA1/SG"){  
					return []
				}else{
					let obj = []
					for (let index = 1; index <= 18; index++) {
						obj.push({
							name:"组串"+index,
							I:"I_Series"+index
						})
					}
					return obj
				}
			},
			//MPPT
			realData(){
				if(this.currentLoop.subLoopUrl == "T1/1AA1/SG"){  //户用逆变器
					return [
						{
							name:"MPPT1",
							U:"U_MPPT1",
							I:"I_MPPT1"
						},
						{
							name:"MPPT2",
							U:"U_MPPT2",
							I:"I_MPPT2"
						},
					]
				}else{
					let obj = []
					for (let index = 1; index <= 9; index++) {
						obj.push({
							name:"MPPT"+index,
							U:"U_MPPT"+index,
							I:"I_MPPT"+index
						})
					}
					return obj
				}
			}
		},
		mounted(){
			this.isActive = this.isCheck
		},
		methods:{
			getMqttVal(f) {
				let currentLoop = this.currentLoop
				return (k, m) => {
					if (currentLoop && k) {
						k = currentLoop.subLoopUrl + "/" + k;
						let mqttVal = f(k);
						mqttVal = floatFormat(mqttVal, 2);
						if (typeof mqttVal === "object") {
							return mqttVal;
						}
						return mqttVal !== undefined && !isNaN(mqttVal) ? mqttVal : "--";
					} else {
						return "--";
					}
				};
			},
		}
	}
</script>

<style scoped lang="less">
	.nodata{
		text-align: center;
		padding-top: 9vh;
	}
	.popup {
		width: 998rem;
		height: 630rem !important;
		position: fixed;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
		background: #ffffff;
		box-shadow: 0rem 4rem 40rem 0rem rgba(0, 43, 102, 0.28);
		// padding: 30rem 48rem 37rem 32rem;
		z-index: 10;

	.tab {
		width: 100%;
		padding: 30rem 32rem 37rem 32rem;
		margin-top: 10rem;
	.head, .row {
	>div {
		min-width: 200rem;
		text-align: left;
		padding: 0 40rem;
	}
	}

	.head {
		font-size: 24rem;
		font-weight: bold;
		color: #333333;
		background: #FAFAFA;
		line-height: 56rem;
		margin-top: 20rem;
		border-bottom: 1rem solid #e5e5e5;
	}

	.rows {
		overflow-y: auto;
		overflow-x: hidden;
		height: 450rem;

	.row {
		font-size: 18rem;
		font-weight: bold;
		color: #333333;
		border-bottom: 1rem solid rgba(229, 229, 229, 1);
		line-height: 48rem;
	}
	}
	}


	.title {
		font-size: 24rem;
		font-weight: bold;
		color: #333333;
		height: 35rem;
		line-height: 75rem;
		padding: 0 30rem;
	.close {
		width: 19rem;
		height: 19rem;
		background-image: url("../../assets/img/关闭.png");
		cursor: pointer;
		position: relative;
		background-repeat: no-repeat;
		background-size: 100% 100%;
		// right: -20rem;
		// top: -10rem;
	}

	.enum {
		>div {
			margin-right: 47rem;
			cursor: pointer;
			font-size: 24rem;
			font-weight: bold;
			border-top: 2px solid #ffffff;
			width: 80rem;
			text-align: center;
			&.active {
				color: #0D94FF;
				border-top: 2px solid #0D94FF;
			}
		}
		
	}


	}
	}
</style>
